import { z } from 'zod';
/** Shared shape for the `Json?` `address` column on `Lead`/`Company`
 * (docs/architecture/03-database.md) — free-form on purpose (international
 * addresses don't fit a rigid line1/line2/state/zip mould everywhere), but
 * validated to these known keys so the app never has to guess what's in
 * the JSON blob. `formatted` is the single-string form a place lookup
 * (Google or otherwise) tends to hand back; `lat`/`lng` are optional map
 * coordinates. */
export const addressSchema = z.object({
    line1: z.string().trim().max(200).optional(),
    line2: z.string().trim().max(200).optional(),
    city: z.string().trim().max(120).optional(),
    state: z.string().trim().max(120).optional(),
    postalCode: z.string().trim().max(30).optional(),
    country: z.string().trim().max(120).optional(),
    formatted: z.string().trim().max(500).optional(),
    lat: z.number().min(-90).max(90).optional(),
    lng: z.number().min(-180).max(180).optional(),
});
//# sourceMappingURL=address.js.map